import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from '../../mixins/translate/translate';
import {
    Content,
    EditPanel,
    EditPanelCell,
    EditPanelRow,
    EditPanelSection,
    EditPanelSwitch,
    Panel,
    PanelBody,
    Topbar,
    TopbarCrumb,
    TopbarCrumbActive,
    TopbarLeft,
    Tray,
} from '../elements';
import { DropzoneComponent } from '../utils/dropzone/DropzoneComponent';

interface IImportCompositionStandardProps {
    match: {
        params: {
            id?: string;
        };
    };
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ImportCompositionStandard = (props: IImportCompositionStandardProps) => {
    const inspectionStandardId = props.match.params.id;
    const translate = useTranslate();
    const [result, setResult] = React.useState<{ isSuccessful: boolean; messages: string[] } | undefined>();
    const [isReplaceComposition, setIsReplaceComposition] = React.useState<boolean>(false);

    function onUploadComplete(response: any) {
        if (response.xhr.status !== 200) {
            setResult({ isSuccessful: false, messages: [response.xhr.responseText] });
        } else {
            const { responseText } = response.xhr;
            setResult(JSON.parse(responseText));
        }
    }

    return (
        <>
            <Topbar>
                <TopbarLeft>
                    <TopbarCrumbActive title={translate('common.importItem', translate('common.inspectionCompositionStandard'))} icon="fa-upload" />
                    <TopbarCrumb>
                        <Link to={`/settings/objecttypes/inspectionstandards/${inspectionStandardId}/editobjecttemplate`}>
                            {translate('common.composition')}
                        </Link>
                    </TopbarCrumb>
                    <TopbarCrumb>
                        <Link to="/settings/objecttypes/">{translate('common.objectTypes')}</Link>
                    </TopbarCrumb>
                </TopbarLeft>
            </Topbar>
            <Content>
                <Tray>
                    <Panel>
                        <PanelBody>
                            <EditPanel>
                                <EditPanelRow>
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={6}>
                                            <EditPanelSwitch
                                                name="replace"
                                                placeholder="Replace current composition"
                                                value={isReplaceComposition}
                                                handleChange={() => setIsReplaceComposition(!isReplaceComposition)}
                                            />
                                        </EditPanelCell>
                                    </EditPanelRow>
                                    <EditPanelSection>
                                        <div className="tray-bin p10 m5" style={{ minHeight: 250 }}>
                                            <h5 className="text-muted mt10 fw600 pl10">
                                                <i className="fa fa-exclamation-circle text-info fa-lg pr10" />
                                                {translate('survey.dragAndDropUploader')}{' '}
                                            </h5>
                                            <DropzoneComponent
                                                className="dropzone-sm"
                                                config={{
                                                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                                                    postUrl: `/api/inspectionStandards/${inspectionStandardId}/import?replace=${isReplaceComposition}`,
                                                }}
                                                djsConfig={{
                                                    parallelUploads: 1,
                                                }}
                                                eventHandlers={{
                                                    complete: onUploadComplete,
                                                }}
                                            />
                                        </div>
                                    </EditPanelSection>
                                    {result !== undefined && (
                                        <EditPanelCell rowCount={6}>
                                            {result.isSuccessful ? 'Import was successful' : 'Import failed'} <br />
                                            Report: <br />
                                            <ul>
                                                {result.messages.map((message, index) => (
                                                    <li key={index}>{message}</li>
                                                ))}
                                            </ul>
                                            <div>
                                                <Link to={`/settings/objecttypes/inspectionstandards/${inspectionStandardId}/editobjecttemplate`}>
                                                    View the composition
                                                </Link>
                                            </div>
                                        </EditPanelCell>
                                    )}
                                </EditPanelRow>
                            </EditPanel>
                        </PanelBody>
                    </Panel>
                </Tray>
            </Content>
        </>
    );
};
